<template>
    <div class="layout-record-list">
        <div v-if="!gotData" class="layout-rl-note">正在加载数据...</div>
        <div v-else class="layout-rl-content" >
            <virtual-list id="RecordList" ref="vsl" class="layout-record-list-list scroll-touch"
                :data-key="'id'"
                :data-sources="recordList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'list-item-fixed'" />
        </div>
    </div>
</template>

<script>
import RecordListItem from '../../components/record/RecordListItem.vue'
export default {
    name: 'RecordVirtualList',
    props: {
        gotData: {
            type: Boolean,
            default() { return false }
        },
        recordList: {
            type: Array,
            default() { return [] }
        }
    },
    data() {
        return {
            itemComponent: RecordListItem
        }
    },
    mounted() {
        this.$bus.on('updateScrollByLetter', this.clickLetterItem)
        this.$bus.on('updateScrollToTop', this.scrollToTop)
    },
    destroyed() {
        this.$bus.off('updateScrollByLetter', this.clickLetterItem)
        this.$bus.off('updateScrollToTop', this.scrollToTop)
    },
    methods: {
        clickLetterItem(index) {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(index);
            }
        },
        scrollToTop() {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(0);
            }
        }
    }
}
</script>